import * as Lucide from "lucide-react";

const CityStats = ({ stats }) => {
  return (
    <section className="py-24 lg:py-32 bg-ink text-white grain-overlay relative overflow-hidden" data-testid="city-stats-section">
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] bg-gold/15 rounded-full blur-[140px] pointer-events-none" />
      <div className="relative container-tm">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="overline text-gold">En quelques chiffres</span>
          <h2 className="mt-5 font-serif font-light text-white text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Terre et Mer
            <span className="italic text-gold"> en quelques chiffres</span>.
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {stats.map((s, i) => {
            const Icon = Lucide[s.icon] || Lucide.Sparkles;
            return (
              <div
                key={s.label}
                data-testid={`city-stat-${i}`}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8 lg:p-10 text-center hover:bg-white/10 transition-colors duration-500"
              >
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-gold/15 mb-5">
                  <Icon size={20} strokeWidth={1.6} className="text-gold" />
                </div>
                <p className="font-serif text-4xl md:text-5xl text-white leading-none tracking-tight">
                  {s.value}
                </p>
                <p className="mt-4 text-[11px] uppercase tracking-[0.22em] font-semibold text-gold">
                  {s.label}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CityStats;
